import web3 from './web3'

// Dirección del creador del contrato
const address = "0xd8C13dfDCC0428e23f7A0bb8b4B1c5Ee66EcB3Da"

//ABI del contrato
const abi = [
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_id",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_price",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_amount",
				"type": "uint256"
			}
		],
		"name": "createAuction",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_index",
				"type": "uint256"
			}
		],
		"name": "deleteAuction",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_index",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_GWEI",
				"type": "uint256"
			}
		],
		"name": "doneAuction",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "returnAllAuctions",
		"outputs": [
			{
				"components": [
					{
						"internalType": "address payable",
						"name": "seller",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "id",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalGWEI",
						"type": "uint256"
					},
					{
						"internalType": "bool",
						"name": "done",
						"type": "bool"
					},
					{
						"internalType": "address payable",
						"name": "buyer",
						"type": "address"
					}
				],
				"internalType": "struct Creating.Auction[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
]
const instance = new web3.eth.Contract(abi, address);

export default instance;




//////////////////
// WEBPACK FOOTER
// ./contracts/energyInstance.js
// module id = null
// module chunks = 